// Normalizes a business area name into a comparable slug
// (strips accents/case so "Hôtel" and "Hotel" both resolve to "hotel")
export function slugifyBusinessArea(name) {
  if (!name) return '';
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[‘’′']/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function isHotelBusinessArea(profile) {
  const businessName = profile?.company?.business_area?.business_name;
  return slugifyBusinessArea(businessName) === 'hotel';
}
